module.exports = __webpack_public_path__ + "77224470.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/p_home/Section/ic_More.png
// module id = 1235
// module chunks = 1